// eslint-disable-next-line no-restricted-globals
export const appHistory = typeof window === "undefined" ? null : window.history;
// eslint-disable-next-line no-restricted-globals
export const appLocation =
  typeof window === "undefined" ? null : window.location;
export default appHistory;
